import { z } from 'zod';
export const ayar = z.object({
    anahtar: z.string(),
    deger: z.string(),
    aciklama: z.string().nullable().optional(),
    guncellemeTarihi: z.string().datetime(),
});
export const ayarSetIstegi = z.object({
    anahtar: z
        .string()
        .trim()
        .min(2)
        .max(80)
        .regex(/^[a-z][a-z0-9_.-]*$/i, 'Sadece harf/rakam/_-.'),
    deger: z.string().max(2000),
    aciklama: z.string().nullable().optional(),
});
export const denetimKaydi = z.object({
    id: z.string(),
    yapanKullaniciId: z.string().nullable().optional(),
    yapanAdSoyad: z.string().nullable().optional(),
    eylem: z.string(),
    kaynak: z.string(),
    oncekiDeger: z.unknown().nullable().optional(),
    yeniDeger: z.unknown().nullable().optional(),
    ipAdresi: z.string().nullable().optional(),
    olusturmaTarihi: z.string().datetime(),
});
export const denetimSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(200).default(100),
    yapanKullaniciId: z.string().optional(),
    eylem: z.string().optional(),
    kaynak: z.string().optional(),
    baslangicTen: z.string().datetime().optional(),
    baslangicAKadar: z.string().datetime().optional(),
});
//# sourceMappingURL=ayar.js.map